// test1580
(1580 && 0);
